"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const auth0_react_1 = require("@auth0/auth0-react");
const react_router_dom_1 = require("react-router-dom");
const components_1 = require("components");
const config_1 = require("config");
const utils_1 = require("utils");
const Views = __importStar(require("./views"));
function Routes() {
    const { isLoading, error } = (0, auth0_react_1.useAuth0)();
    const location = (0, react_router_dom_1.useLocation)();
    if (error) {
        const { pathname: applicationPath } = location;
        const errorStr = error.toString();
        const isErrorExpiration = errorStr.toLowerCase().includes('expiration time');
        if (isErrorExpiration) {
            return (0, utils_1.forceRedirect)({ to: config_1.ERROR_EXPIRATION_ERROR_URL });
        }
        const authorizationErrorPath = (0, utils_1.makeQueryPath)(config_1.PATH.AUTHORIZATION_ERROR, {
            ...error,
            [config_1.QUERY_KEY.APPLICATION_PATH]: applicationPath,
        });
        return (0, utils_1.forceRedirect)({ to: authorizationErrorPath });
    }
    if (isLoading)
        return (0, jsx_runtime_1.jsx)(components_1.Spinner, { centerPage: true });
    return ((0, jsx_runtime_1.jsx)(components_1.AuthenticatedRoutes, { children: (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { exact: true, path: config_1.PATH.ADMIN, children: (0, jsx_runtime_1.jsx)(Views.AdminPortal, {}) }) }));
}
exports.default = Routes;
